import {
  IMAGENES_ARTICULOS_OBTENER_IMAGENES_REQUEST,
  ARTICULOS_FILTROS_REQUEST,
} from '../constants/articulos.constants';

export const obtenerImagenesArticulosRequest = ({ articulos }) => ({
  type: IMAGENES_ARTICULOS_OBTENER_IMAGENES_REQUEST,
  payload: {
    articulos,
  },
});

export const obtenerFiltrosFromGw1 = () => ({
  type: ARTICULOS_FILTROS_REQUEST,
});
